import * as React from "react";
export class Item extends React.Component {
    /* istanbul ignore next */
    void() { }
    render() {
        let h = this.props.handler || this.void;
        return (React.createElement("div", { className: "rj-racing-next-races__item" },
            this.props.children,
            React.createElement("a", { className: "rj-racing-next-races__view", href: this.props.url, onClick: /* istanbul ignore next */ (event) => h(event), "data-uat": "view-event-button-next-races" }, this.props.label)));
    }
}
//# sourceMappingURL=Item.js.map